import { Injectable } from '@angular/core';
import { AuthentificationService } from '@app/authentification/authentification.service';

import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Observable } from 'rxjs';
import { Dao } from '../dao';

@Injectable({
  providedIn: 'root',
})
export class NifValidatorDao extends Dao {
  constructor(
    httpApi: HttpApiService,
    authentificationService: AuthentificationService,
  ) {
    super(httpApi, authentificationService);
  }

  validate(nif: string): Observable<any> {
    return this.httpApi.post(`/nif/validator`, { nif });
  }

  /* state */
  reset() {}

  onUserChange(event: any) {
    this?.reset();
  }
}
